<div class="container tw-flex tw-items-center tw-justify-center">
  <svg [attr.width]="size" [attr.height]="size" viewBox="0 0 157 126" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="#eb4d4bdb" fill-rule="evenodd">
      <g id="Desktop" transform="translate(-267.000000, -301.000000)" stroke="#000000">
        <g id="Heart-Group" transform="translate(278.000000, 311.000000)">
          <path d="M66.6562543,13.6106531 C115.669926,-30.8795812 193.14986,44.3686482 66.6562543,104.323088 C-54.0630308,44.3686482 16.35352,-31.3170812 66.6562543,13.6106531 Z" id="heart" [attr.stroke-dashoffset]="400 - (percentage * 400)/100"></path>
        </g>
      </g>
    </g>
  </svg>
</div>